(function peachadeGiftWrap() {
  if (window.__peachadeGiftWrap) return;
  window.__peachadeGiftWrap = true;

  const PROPERTY = 'Gift Wrapped';
  const PROPERTY_VALUE = 'Yes';
  const LEGACY_PROPERTY = 'Peach Gift Bag wrapping';
  const BAG_HANDLE = 'peach-gift-bag';
  const BOX_HANDLE = 'gift-box-wrapping';
  const WRAPIT_HANDLE = 'wrapit-gift-wraps';
  let syncing = false;
  let boxSyncing = false;
  let strippingWrapit = false;

  const bagVariantId = () => {
    const el = document.querySelector('[data-gift-wrap-toggle][data-bag-variant-id]');
    const fromEl = Number(el?.dataset.bagVariantId || 0);
    return fromEl || Number(theme.giftWrap?.bagVariantId || 0);
  };

  const boxVariantId = () => {
    const el = document.querySelector('[data-gift-wrap-box-toggle]');
    const fromEl = Number(el?.dataset.boxVariantId || 0);
    return fromEl || Number(theme.giftWrap?.boxVariantId || 0);
  };

  const isWrappedItem = (item) => {
    const props = item.properties || {};
    return !!(props[PROPERTY] || props[LEGACY_PROPERTY] || props['Gift wrapped']);
  };

  const isBagItem = (item) => item.handle === BAG_HANDLE || item.variant_id === bagVariantId();

  const isBoxItem = (item) => item.handle === BOX_HANDLE || item.variant_id === boxVariantId();

  const isWrapitItem = (item) => item.handle === WRAPIT_HANDLE;

  const bundleSections = () => {
    const sections = [];
    document.documentElement.dispatchEvent(new CustomEvent('cart:bundled-sections', { bubbles: true, detail: { sections } }));
    return sections;
  };

  const jsonFetch = (url, body) =>
    fetch(url, { ...theme.utils.fetchConfig(), body: JSON.stringify(body) }).then((res) => res.json());

  const publishCart = async (parsedState) => {
    const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
    if (parsedState?.sections) cartJson.sections = parsedState.sections;
    theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'gift-wrap', cart: cartJson });
    document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cartJson } }));
    return cartJson;
  };

  const wrappedQuantity = (cart) =>
    (cart.items || []).reduce((sum, item) => {
      if (isBagItem(item) || isBoxItem(item) || isWrapitItem(item) || !isWrappedItem(item)) return sum;
      return sum + item.quantity;
    }, 0);

  const bagItem = (cart) => (cart.items || []).find(isBagItem);

  const syncBagQuantity = async (cart) => {
    if (syncing) return cart;
    const wanted = wrappedQuantity(cart);
    const bag = bagItem(cart);
    const current = bag ? bag.quantity : 0;
    if (wanted === current) return cart;

    syncing = true;
    try {
      const sections = bundleSections();
      let parsed;
      if (wanted === 0 && bag) {
        parsed = await jsonFetch(theme.routes.cart_change_url, { id: bag.key, quantity: 0, sections, sections_url: window.location.pathname });
      } else if (!bag && wanted > 0) {
        parsed = await jsonFetch(theme.routes.cart_add_url, {
          items: [{ id: bagVariantId(), quantity: wanted, properties: { _peachade_wrap_bag: '1' } }],
          sections,
          sections_url: window.location.pathname
        });
      } else if (bag) {
        parsed = await jsonFetch(theme.routes.cart_change_url, { id: bag.key, quantity: wanted, sections, sections_url: window.location.pathname });
      }
      if (parsed) return publishCart(parsed);
    } finally {
      syncing = false;
    }
    return cart;
  };

  const stripWrapit = async (cart) => {
    if (strippingWrapit) return cart;
    const wrapit = (cart.items || []).find(isWrapitItem);
    if (!wrapit) return cart;
    strippingWrapit = true;
    try {
      const parsed = await jsonFetch(theme.routes.cart_change_url, {
        id: wrapit.key,
        quantity: 0,
        sections: bundleSections(),
        sections_url: window.location.pathname
      });
      if (parsed?.status) return cart;
      return publishCart(parsed);
    } catch (error) {
      console.error(error);
      return cart;
    } finally {
      strippingWrapit = false;
    }
  };

  const setBoxWrapped = async (wrapOn) => {
    if (boxSyncing) return;
    const cart = await (await fetch(`${theme.routes.cart_url}.js`)).json();
    const box = (cart.items || []).find(isBoxItem);
    if (wrapOn && box) return;
    if (!wrapOn && !box) return;

    const variantId = boxVariantId();
    if (wrapOn && !variantId) return;

    boxSyncing = true;
    try {
      const sections = bundleSections();
      const sectionsUrl = window.location.pathname;
      let parsed;
      if (wrapOn) {
        parsed = await jsonFetch(theme.routes.cart_add_url, {
          items: [{ id: variantId, quantity: 1, properties: { _peachade_box_wrap: '1' } }],
          sections,
          sections_url: sectionsUrl
        });
      } else {
        parsed = await jsonFetch(theme.routes.cart_change_url, {
          id: box.key,
          quantity: 0,
          sections,
          sections_url: sectionsUrl
        });
      }
      if (parsed?.status) return;
      await publishCart(parsed);
    } catch (error) {
      console.error(error);
    } finally {
      boxSyncing = false;
    }
  };

  const addWrappedFromForm = async (form) => {
    const wrap = form.querySelector('[data-gift-wrap-toggle]');
    const submitButton = form.querySelector('[type="submit"]') || document.querySelector(`[type="submit"][form="${form.id}"]`);
    const formData = new FormData(form);
    const quantity = parseInt(formData.get('quantity') || '1', 10) || 1;
    const id = Number(formData.get('id'));
    const bagId = Number(wrap.dataset.bagVariantId);
    const properties = {};
    for (const [key, value] of formData.entries()) {
      const match = key.match(/^properties\[(.+)\]$/);
      if (match && value) properties[match[1]] = value;
    }
    properties[PROPERTY] = PROPERTY_VALUE;
    delete properties[LEGACY_PROPERTY];

    if (submitButton) {
      submitButton.setAttribute('aria-disabled', 'true');
      submitButton.setAttribute('aria-busy', 'true');
    }

    try {
      const parsedState = await jsonFetch(theme.routes.cart_add_url, {
        items: [
          { id, quantity, properties },
          { id: bagId, quantity, properties: { _peachade_wrap_bag: '1' } }
        ],
        sections: bundleSections(),
        sections_url: window.location.pathname
      });

      if (parsedState.status) {
        theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartError, {
          source: 'product-form',
          productVariantId: String(id),
          errors: parsedState.errors || parsedState.description,
          message: parsedState.message
        });
        return;
      }

      const cartJson = await (await fetch(theme.routes.cart_url, { ...theme.utils.fetchConfig('json', 'GET') })).json();
      cartJson.sections = parsedState.sections;
      theme.pubsub.publish(theme.pubsub.PUB_SUB_EVENTS.cartUpdate, { source: 'product-form', productVariantId: String(id), cart: cartJson });
      document.dispatchEvent(new CustomEvent('ajaxProduct:added', { detail: { product: parsedState } }));
      document.querySelector('cart-drawer')?.show(submitButton);
    } catch (error) {
      console.error(error);
    } finally {
      if (submitButton) {
        submitButton.removeAttribute('aria-busy');
        submitButton.removeAttribute('aria-disabled');
      }
    }
  };

  document.addEventListener('submit', (event) => {
    const form = event.target;
    if (!(form instanceof HTMLFormElement) || form.getAttribute('is') !== 'product-form') return;
    const wrap = form.querySelector('[data-gift-wrap-toggle]');
    if (!wrap?.checked || !wrap.dataset.bagVariantId) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    addWrappedFromForm(form);
  }, true);

  document.addEventListener('change', (event) => {
    const boxInput = event.target.closest('[data-gift-wrap-box-toggle]');
    if (boxInput) {
      boxInput.setAttribute('aria-checked', boxInput.checked ? 'true' : 'false');
      event.preventDefault();
      event.stopImmediatePropagation();
      setBoxWrapped(boxInput.checked);
      return;
    }
    const input = event.target.closest('[data-gift-wrap-toggle]');
    if (!input) return;
    input.setAttribute('aria-checked', input.checked ? 'true' : 'false');
  }, true);

  document.addEventListener('cart:updated', (event) => {
    const cart = event.detail?.cart;
    if (!cart?.items || syncing || boxSyncing || strippingWrapit) return;
    if ((cart.items || []).some(isWrapitItem)) {
      stripWrapit(cart);
      return;
    }
    const wanted = wrappedQuantity(cart);
    const bag = bagItem(cart);
    const current = bag ? bag.quantity : 0;
    if (wanted !== current) syncBagQuantity(cart);
  });

  fetch(`${theme.routes.cart_url}.js`)
    .then((res) => res.json())
    .then((cart) => {
      if ((cart.items || []).some(isWrapitItem)) stripWrapit(cart);
    })
    .catch(() => {});
})();
